import React from 'react';
import { InputNumber as AntInputNumber } from 'antd';

/**
 * Componente de InputNumber
 * @param {string} placeholder - Placeholder do input
 * @param {number} value - Valor do input
 * @param {function} onChange - Função de mudança
 * @param {number} min - Valor mínimo
 * @param {number} max - Valor máximo
 * @param {number} step - Passo de incremento/decremento
 * @param {boolean} disabled - Se o input está desabilitado
 * @param {string} size - Tamanho do input (large, middle, small)
 */
const InputNumber = ({ 
  placeholder = '', 
  value = null, 
  onChange = () => {}, 
  min = undefined,
  max = undefined,
  step = 1,
  disabled = false,
  size = 'middle',
  ...props 
}) => {
  return (
    <AntInputNumber
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      size={size}
      style={{ width: '100%' }}
      {...props}
    />
  );
};

export default InputNumber;



